<template>
  <div
    @click="$emit('click')"
    class='new-report-of-sickness-card-button'>

    <div class='text-container'>
      <p class='sub'>Ik wil een</p>
      <p class='main'>nieuw verzuim</p>
      <p class='sub'>indienen.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewReportOfSicknessCardButton'
};
</script>

<style lang='scss' scoped>
  @import '@/assets/stylesheets/variables.scss';

  .new-report-of-sickness-card-button {
   position: relative;
    width: 100%;
    cursor: pointer;

    border-radius: $border-radius;
    padding: 17px;
    background-color: $secondary-lighten-4;
    line-height: 1.5em;
    min-height: 150px;

    &:hover {
      background-color: lighten($secondary-lighten-4, 2%);
    }

    .text-container {
      position: absolute;
      bottom: 17px;
    }

    .sub {
      color: $secondary-darken-1;
    }
    .main {
      color: $quinary;
      font-weight: 700;
      font-size: 1.2em;
    }
  }
</style>
